<script>
  import { onDestroy } from "svelte"
  import backend from "~/backend"
  import ImageUpload from "~/components/ImageUpload.svelte"
  import Gallery from "~/components/Gallery.svelte"

  export let initialData

  const { id, gallery } = initialData.journal
  let { date, title, body } = initialData.journal

  let initialRender = true

  let saving = 0
  let savingTimeout
  async function persistChanges(date, title, body) {
    saving = 1
    backend.updateJournal(id, { date, title, body }, () => {
      savingTimeout = setTimeout(() => {
        saving = 2
        savingTimeout = setTimeout(() => {
          saving = 0
        }, 5000)
      }, 1000)
    })
  }

  let timer

  const debouncedUpdate = (date, title, body) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      persistChanges(date, title, body)
    }, 1000)
  }

  $: {
    if (initialRender) {
      initialRender = false
    } else {
      debouncedUpdate(date, title, body)
    }
  }
  onDestroy(() => clearTimeout(savingTimeout))
</script>

<main>
  <div class="flex flex-col-reverse md:flex-row md:space-x-10">
    <div class="w-full md:w-3/12">
      <Gallery {gallery} />
      <ImageUpload server={`${id}/upload_image`} />
    </div>
    <div class="space-y-4 w-full md:w-9/12">
      <div class="flex flex-col md:flex-row md:items-center">
        <input
          id="title"
          type="text"
          class="flex-grow font-light text-accent text-3xl w-full border-0 bg-transparent focus:ring-0 ring-0 outline-none focus:outline-none py-2"
          bind:value={title}
        />

        {#if saving == 1}
          <div class="text-primary">Saving...</div>
        {:else if saving == 2}
          <div class="text-success">Saved</div>
        {/if}
        <input
          id="date"
          type="text"
          size="8"
          class="font-light text-slate md:text-right border-0 bg-transparent focus:ring-0 ring-0
          outline-none focus:outline-none py-2 md:px-4"
          bind:value={date}
        />
      </div>

      <div
        id="entry"
        contenteditable
        class="w-full min-h-[400px] text-lg md:text-lg outline-none"
        bind:innerHTML={body}
      />
    </div>
  </div>
</main>

<style>
  #title {
    font-family: "LXGW WenKai TC";
  }

  #entry {
    background-image: linear-gradient(
      rgba(38, 76, 115, 0.1) 1px,
      transparent 1px
    );
    background-size: 100% 1.6em;
    background-origin: content-box;
    line-height: 1.6;
    overflow: hidden;
    overflow-wrap: break-word;

    font-family: "LXGW WenKai TC";
  }
</style>
